<script>
export default {
  name: "SurveySuccess"
}
</script>

<template>
  <section class="section-two bg-light mt-5 mb-2">
  <div class="container text-center">
    <h2 class="text-success">✅ Obrigado por responder!</h2>
    <p class="mt-3">Sua opinião é muito importante para nós.</p>
    <router-link to="/" class="btn btn-primary mt-4">Voltar para o início</router-link>
  </div>
  </section>
</template>

<style scoped>

</style>